import { getOpenId } from '@/api/api.js'
import requests from '@/api/request.js'
// import tools from '@/tools/tools.js'

let config = function (router) {
  return {
    router,
    // secret: 'eb1472b017a90d5e2327b52485e61e9b', // 微信appsecret
    responseType: 'code',  // 返回类型，请填写code
    scope: 'snsapi_base', // 应用授权作用域，snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且，即使在未关注的情况下，只要用户授权，也能获取其信息）
    getCodeCallback (code, next, redirect) {
      // 用户同意授权后回调方法
      // code：用户同意授权后，获得code值
      // code说明： code作为换取access_token的票据，每次用户授权带上的code将不一样，code只能使用一次，5分钟未被使用自动过期。
      // next： 无论access_token是否获取成功,一定要调用该方法
      // next说明：next方法接收两个参数
      // 参数1为通过code值请求后端获取到的access_token值，如果获取失败请填入空字符串''
      // 参数2(非必填，默认获取access_token切换到当前路由对象)，指定切换对象 next('/') 或者 next({ path: '/' })
      // axios({
      //   method: 'post',
      //   baseUrl: baseUrl,
      //   url: getOpenId,
      //   data: {
      //     code: code,
      //     appid: window.localStorage.getItem('appId')
      //   }
      // })
      // tools.saveLog('开始获取openId', `
      //   DateTime: ${new Date().format('yyyy-MM-dd HH:mm:ss')}
      // `)
      requests.post(getOpenId, {
        code: code,
        appid: window.localStorage.getItem('appId')
      }).then(response => {
        // tools.saveLog('getOpen response', `
        //   DateTime: ${new Date().format('yyyy-MM-dd HH:mm:ss')},
        //   response: ${JSON.stringify(response)},
        //   openId: ${response['openId']}
        // `)
        let openId = response['openId']
        if (openId) {
          window.localStorage.setItem('openId', openId)
          next(openId, redirect) // 获取access_toeken成功
        } else {
          next('', '/notlogin') // 获取access_token失败
        }
      }).catch((e) => {
        // tools.saveLog('getOpen error', `
        //   DateTime: ${new Date().format('yyyy-MM-dd HH:mm:ss')},
        //   path: ${window.location.href}
        // `)
        let path = window.location.href
        const index = path.indexOf('#') + 1
        path = path.substring(index)
        next('', path) // ajax出现错误
      })
    }
  }
}

export default config



// WEBPACK FOOTER //
// ./src/config/WechatConfig.js